import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92c83156"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Item Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Item Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Item Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Item Name")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "up"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "up"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil((_ctx.table[_ctx.rarity].length - 1) / 2), (row) => {
      return (_openBlock(), _createElementBlock("tr", { key: row }, [
        _createElementVNode("td", null, _toDisplayString(_ctx.table[_ctx.rarity][(row - 1) * 2].type), 1),
        _createElementVNode("td", null, [
          (_ctx.table[_ctx.rarity][(row - 1) * 2].featured)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.table[_ctx.rarity][(row - 1) * 2].name), 1)
        ]),
        (_ctx.table[_ctx.rarity][(row - 1) * 2 + 1])
          ? (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(_ctx.table[_ctx.rarity][(row - 1) * 2 + 1].type), 1))
          : _createCommentVNode("", true),
        (_ctx.table[_ctx.rarity][(row - 1) * 2 + 1])
          ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
              (_ctx.table[_ctx.rarity][(row - 1) * 2 + 1].featured)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.table[_ctx.rarity][(row - 1) * 2 + 1].name), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}